var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"consultant-promise"},[_c('span',{staticClass:"promise-title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"tx"},[_vm._v("咨询免费，来电即可享受专属服务")])])}
var staticRenderFns = []

export { render, staticRenderFns }